'use strict';

var React = require('react');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var React__default = /*#__PURE__*/_interopDefaultCompat(React);

function SvgVolume(props) {
    return (React__default.default.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg", ...props },
        React__default.default.createElement("g", { fill: "none", fillRule: "evenodd" },
            React__default.default.createElement("path", { d: "M0 0h16v16H0z" }),
            React__default.default.createElement("path", { d: "M2 2h12v12H2z" }),
            React__default.default.createElement("path", { d: "M7.445 12.464c.42 0 .738-.312.738-.732V4.296a.739.739 0 00-.744-.756c-.282 0-.48.114-.791.396L4.62 5.806c-.03.025-.054.037-.09.037H3.217C2.42 5.843 2 6.275 2 7.12v1.763c0 .846.42 1.278 1.217 1.278h1.314c.036 0 .066.012.09.036l2.027 1.895c.288.258.51.372.797.372zm4.756-.876c.27.168.606.102.786-.174C13.628 10.473 14 9.261 14 8.002c0-1.26-.36-2.477-1.013-3.413a.563.563 0 00-.786-.173c-.294.173-.33.533-.126.857.492.756.78 1.727.78 2.729a5.118 5.118 0 01-.78 2.728c-.204.324-.168.684.126.858zm-2.129-1.331a.563.563 0 00.768-.144c.407-.558.635-1.326.635-2.111 0-.786-.228-1.547-.635-2.111a.557.557 0 00-.768-.144c-.294.186-.354.534-.12.893.246.354.384.858.384 1.362 0 .504-.144 1.001-.384 1.361-.228.366-.174.708.12.894z", fill: "currentColor" }))));
}

module.exports = SvgVolume;
//# sourceMappingURL=Volume.js.map
